import React from 'react'
import { useNewTrip } from '@/modules/drivers/context/NewTripContext'
import BusinessTripActionBar from '../components/BusinessTripActionBar'

const AddBusinessTripActionBar = ({
  showImport,
  onShowTmsLoads,
  onShowCardLoads,
  onShowBorders,
  onShowEvents,
  onGenerateTrips,
  isRestsOnBaseModeOn,
  setIsRestsOnBaseModeOn,
}: {
  showImport: boolean
  companyId?: string
  driverId?: number
  dateFrom?: any
  dateToMoment?: any
  onShowTmsLoads?: () => void
  onShowCardLoads?: () => void
  onShowBorders?: () => void
  onShowEvents?: () => void
  onGenerateTrips?: (generationMode: number) => void | Promise<void>
  isRestsOnBaseModeOn: boolean
  setIsRestsOnBaseModeOn: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const { events } = useNewTrip()

  if (showImport) return null

  return (
    <BusinessTripActionBar
      events={events}
      isRestsOnBaseModeOn={isRestsOnBaseModeOn}
      setIsRestsOnBaseModeOn={setIsRestsOnBaseModeOn}
      onShowTmsLoads={onShowTmsLoads}
      onShowCardLoads={onShowCardLoads}
      onShowBorders={onShowBorders}
      onShowEvents={onShowEvents}
      onGenerateTrips={onGenerateTrips}
    />
  )
}

export default AddBusinessTripActionBar
